import IconButtonMantis from 'mantis/components/@extended/IconButton';

const IconButton = (props) => {
	return <IconButtonMantis {...props} />;
};

export default IconButton;
